import { render, staticRenderFns } from "./ProtocolPreview.vue?vue&type=template&id=64cbe155&scoped=true"
import script from "./ProtocolPreview.vue?vue&type=script&lang=js"
export * from "./ProtocolPreview.vue?vue&type=script&lang=js"
import style0 from "./ProtocolPreview.vue?vue&type=style&index=0&id=64cbe155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbe155",
  null
  
)

export default component.exports